import SectionHeading from "../components/SectionHeading";
import "./About.css";

const INTRO = [
  "🎓 Welcome to Agape Garden, where we have been caring for and guiding young children for the past eight years. We understand that the early years are an important time in a child's life, and our preschool and day care programs are designed to give children a safe, happy, and caring place to learn and grow.",
  "🌱 At Agape Garden, we believe children learn best when they feel comfortable, loved, and encouraged. Through play, everyday activities, and age-appropriate learning, we help children become more independent, build confidence, communicate well, and develop the skills they need as they grow.",
  "🏫 Our preschool and day care center provides a clean, comfortable, and child-friendly environment where children can learn, play, rest, and make friends. Our classrooms and play areas are designed around the needs of young children, giving them plenty of opportunities to explore, learn, and enjoy their time with us.",
];

const PILLARS = [
  {
    title: "Mission",
    image: "/motion/1.png",
    deco: { src: "/motion/Line.png", side: "right" },
    text: "Our mission is to provide children with a caring and supportive environment where they can learn through play and everyday experiences. We focus on building confidence, independence, good habits, and a love for learning while giving every child the care and attention they need.",
  },
  {
    title: "Vision",
    image: "/motion/2.png",
    deco: { src: "/motion/green-star.png", side: "left" },
    reverse: true,
    text: "Our vision is to create a warm and welcoming preschool and day care center where children feel happy, safe, and valued. We aim to give every child a strong start by encouraging curiosity, creativity, communication, and positive relationships through play-based learning and meaningful activities.",
  },
  {
    title: "Award",
    image: "/motion/3.png",
    deco: { src: "/motion/pink-star.png", side: "right" },
    text: "We are proud of the recognition we have received for our efforts in early childhood education and child care. These achievements encourage us to continue providing a safe, caring, and engaging environment where children can learn, grow, and enjoy their early years.",
  },
];

export default function About() {
  return (
    <>
      <section className="about-intro">
        <div className="container about-intro__grid">
          <div>
            <SectionHeading as="h1" plain="About" accent="Us" />
            <div className="about-intro__text">
              {INTRO.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </div>
          <img className="about-intro__photo" src="/images/poly1.png" alt="" />
        </div>
      </section>

      <img className="about-wave" src="/images/curve.png" alt="" />

      <section className="section about-pillars">
        <div className="container">
          {PILLARS.map(({ title, image, deco, reverse, text }) => (
            <div key={title} className="pillar-row">
              <article className={`pillar${reverse ? " pillar--reverse" : ""}`}>
                <img className="pillar__image" src={image} alt="" />
                <div>
                  <h2>{title}</h2>
                  <p>{text}</p>
                </div>
              </article>
              <img
                className={`pillar-row__deco pillar-row__deco--${deco.side}`}
                src={deco.src}
                alt=""
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}